import { VerboseFormattingArg } from "@fullcalendar/core/internal";
import moment from "moment-timezone";

export function TimeGridDayTitleFormat(date: VerboseFormattingArg) {
  return moment(date.date).format("ddd, MMM Do");
}
